export default {
    generateContentModal: {
        title: 'Generar Contenido',
        type: 'Tipo',
        typePlaceholder: 'Seleccione el tipo',
        typeEmptyError: 'Por favor, seleccione el tipo',
        context: 'Contexto',
        contextPlaceholder: 'Seleccione el contexto',
        contextEmptyError: 'Por favor, seleccione el contexto',
        contentTitle: 'Título del contenido',
        contentTitlePlaceholder: 'Añada el tema de tu contenido',
        contentTitleEmptyError: 'Por favor, escriba el título',
        contentTitleInvalidError: 'Por favor, escriba un título válido',
        description: 'Proporcione una breve descripción del contenido',
        descriptionPlaceholder: 'Añada la descripción de su contenido en 2-3 líneas',
        descriptionEmptyError: 'Por favor, escriba la descripción',
        descriptionInvalidError: 'Por favor, escriba una descripción válida',
        addKeywords: 'Añada palabras clave',
        addKeywordsEmptyError: 'Por favor, escriba las palabras clave',
        writingTone: 'Tono de redacción',
        writingTonePlaceholder: 'Eliga el tono de la redacción',
        writingToneEmptyError: 'Por favor, eliga el tono de la redacción',
        numberOfVariations: 'Número de variantes',
        numberOfVariationsEmptyError: 'Por favor, selecciona el número de variantes',
        numberOfVariationsInvalidError: 'Puede generar un máximo de 5 y un mínimo de 1 variante.',
        generate: 'Generar',
        additionalOptions: 'Opciones adicionales',
        clear: 'Claro',
        writingToneOptions: {
            funny: 'Divertido',
            casual: 'Casual',
            excited: 'Entusiasta',
            professional: 'Profesional',
            witty: 'Simpático',
            sarcastic: 'Sarcástico',
            feminine: 'Femenino',
            masculine: 'Masculino',
            bold: 'Audaz',
            dramatic: 'Dramático',
            grumpy: 'Malhumorado',
            secretive: 'Reservado',
            respectful: 'Respetuoso',
            persuasive: 'Persuasivo',
        },
        contextOptions: {
            promotional: 'Promocional',
            introduction: 'Introducción',
            couponDiscount: 'Cupón/Descuento',
            recurringNewsletter: 'Boletín recurrente',
            testimonial: 'Testimonio',
            coldOutreach: 'Prospección fría',
            contentGiveaway: 'Contenido/Sorteo',
            other: 'Otro',
        },
        typeOptions: {
            outline: 'Esquema',
            introduction: 'Introducción',
            section: 'Sección',
        },
    },
};
